export default {
  move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  },
  extractHash(string) {
    if (string) {
      var splitedUrl = string.split('#');
      if (splitedUrl[1]) return splitedUrl[1];
      else if (splitedUrl[0]) return splitedUrl[0];
    }
    return undefined;
  },
  compare(arr1, arr2) {
    if (!arr1 || !arr2) return false;

    if (arr1.length === 0 && arr2.length === 0) return true;

    let result = false;

    arr1.forEach((e1, i) =>
      arr2.forEach((e2) => {
        if (e1.length > 1 && e2.length) {
          result = compare(e1, e2);
        } else if (e1 !== e2) {
          result = false;
        } else {
          result = true;
        }
      })
    );

    return result;
  },
};
